import moment from 'moment'

export const Date = ({
  children = '2022-06-30T06:16:59.241Z',
}: {
  children: string
}) => {
  const formattedDate = moment(children).format('MM.DD.YYYY')
  return <>{formattedDate}</>
}
